import { useState } from 'react';

function useLoading() {
  const [isLoading, setIsLoading] = useState(false);

  function start() {
    setIsLoading(true);
  }

  function stop() {
    setIsLoading(false);
  }

  return {
    isLoading,
    start,
    stop
  };
}

export default useLoading;
